/**
 * The renter↔business conversation is one continuous simulated thread that
 * the walkthrough revisits three times (inquiry, confirmation link, review
 * link). Centralizing the script here keeps all three visits consistent and
 * lets RenterWalkthroughStage assemble "static history" + "new message" for
 * whichever phase is current without duplicating copy.
 */
export function inquiryScript(vehicleName, businessName) {
  return [
    { from: "customer", text: `Hi, is the ${vehicleName} available Friday to Sunday?` },
    { from: "business", text: "Yes. Pickup around 9 AM?" },
    { from: "customer", text: "Yes, return Sunday around 6 PM." },
    { from: "business", text: "Okay, I'll record your booking and send you the ConfirmPH link." },
  ];
}

export function confirmationLinkMessage(businessName, confirmUrl) {
  return {
    prefix: `Here is your ConfirmPH confirmation for ${businessName}:`,
    linkText: confirmUrl,
    staticText: `Here is your ConfirmPH confirmation for ${businessName}: ${confirmUrl}`,
  };
}

export function reviewLinkMessage(businessName, reviewUrl) {
  return {
    prefix: "Thanks for renting with us! You can leave your review here:",
    linkText: reviewUrl,
    staticText: `Thanks for renting with us! You can leave your review here: ${reviewUrl}`,
  };
}
